import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Footer from "../../sidebar/Footer";
import SocialMediaIcons from "./SocialMedia";
import SalesPageFooter from "./SalesPageFooter";

const WelcomePage = () => {
    const navigate = useNavigate();
    const GoButton = () => {
        navigate("/pk/subscription");
    }
    return (
        <section className="container min-vh-100 d-flex flex-column justify-content-between">
            {/* Header Section */}
            <header className="text-center py-0 mt-5">
                <img
                    className="img-fluid"
                    src="../assets/images/logo.svg"
                    alt="FRAYO Logo"
                    style={{ height: "80px" }}
                />
                <h1 className="fw-bold text-success mt-4">Welcome to FRAYO Affiliate</h1>
                <p className="text-muted mt-3 ">
                    Elevate your culinary journey with subscription plans designed for chefs and food enthusiasts alike.
                </p>
            </header>

            {/* Description Section */}
            <section className="text-center my-1 ">
                <p className="text-muted py-5">
                    <strong className="text-success">FRAYO</strong> offers flexible subscription plans to meet diverse needs. Whether you're a chef
                    growing your business or a food lover exploring gourmet delights, our platform provides all the tools and opportunities you need to succeed.
                </p>
                <button className="btn btn-outline-success mt-3 rounded-5 px-4 md-3"
                    onClick={GoButton}>Go</button><br />
            </section>

            {/* Footer Section */}
            <div className="mt-auto">
                <SalesPageFooter />
            </div>
        </section>
    );
};

export default WelcomePage;
